import { useDispatch } from "react-redux";

import { UserPlusRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../shared";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import ActivityBtns from "./shared/ActivityBtns";

import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";

const NewLeadActivity = ({ activity, onReadChange }) => {
  const queryParams = new URLSearchParams();
  queryParams.set("tab", "3");

  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} queryParams={queryParams.toString()} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName="tw-bg-[#FAF1E6] tw-text-[#AD6714]" Icon={UserPlusRegularV6}>
            New Lead
          </CategoryContainer>
        }
        personName={`${activity.data.subjectFirstName} ${activity.data.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <DataField label="Source" data={activity.data.leadSource} />
        <ActivityBtns
          callHandlr={() => {
            if (activity?.personUuid) {
              dispatch(setCallParams({ leadUuids: [activity.personUuid], callSource: "New Lead Activity" }));
            }
          }}
          containerClassName="!tw-mt-8px"
        />
      </div>
    </ActivityContainer>
  );
};

export default NewLeadActivity;

NewLeadActivity.propTypes = {
  ...activityCommonPropTypes,
};

NewLeadActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
